/**
 * Diagnostic events for quick quote step 1, sent through Zaraz.
 *
 * Step 1 loses about 84% of the visitors who open it (GA4, 23-29 Sep 2026:
 * 2,814 opened, 440 sent). These events show where: first tap, Turnstile
 * ready or failed, taps on Submit before verification, browser validation
 * errors and server errors. They carry field names, reasons and timings
 * only, never what the visitor typed.
 *
 * Zaraz forwards a zaraz.track() call to GA4 only when a Zaraz action
 * listens for it; the "^qq1_" trigger in Zaraz does that.
 */
type Props = Record<string, string | number>;

export function qqTrack(name: string, props: Props = {}): void {
  if (typeof window === "undefined") return;
  try {
    const zaraz = (window as unknown as { zaraz?: { track?: (n: string, p: Props) => void } }).zaraz;
    zaraz?.track?.(name, props);
  } catch {
    /* diagnostics must never affect the form */
  }
}

/** Milliseconds since the page started loading, rounded. */
export function msSinceLoad(): number {
  return typeof performance === "undefined" ? 0 : Math.round(performance.now());
}
